import React from "react";

import { Icon } from "components/Icon";
import styled from "styled-components";

import { debounce } from "utils";


import { Form, Input, InputGroup } from "rsuite";

export default ({
    onChangeFilter
}) => {

    return (
        <StyledField>
            <Form onChange={debounce((value) => onChangeFilter(value), 700)}>
                <InputGroup>
                    <Form.Control
                        name="str"
                        accepter={Input}
                        placeholder={"Sound filename, IVR, CLI, phone or account"}
                    />
                    <InputGroup.Addon>
                        <Icon icon="search" />
                    </InputGroup.Addon>
                </InputGroup>
            </Form>
        </StyledField>
    );
};

const StyledField = styled.div`
    max-width: 400px;
`;